<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            消费汇总统计
        </div>
        <div style="padding: 20px;">
            <div>
                <el-row>
                    <div style="float:right">
                        <span class="demonstration">所属区域：</span>
                        <elSelectTree :options='zoneValue' accordion :props="zoneProps" placeholder="请选择所属区域" v-on:getZoneValue="getZoneValue" style="width:250px;margin-right:20px"></elSelectTree>
                        <span class="demonstration">起止时间：</span>
                        <el-date-picker
                            ref="picker"
                            v-model="datetimerangeValue"
                            type="daterange"
                            :clearable='false'
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width:250px;margin-right:20px">
                        </el-date-picker>
                        <el-button type="success" icon="el-icon-download" style="margin-right:10px;" @click="download">导出</el-button>
                        <el-button  type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
                    </div>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>
                    <el-table :data="tableData" border show-summary :summary-method="getSummaries" style="width: 100%">
                        <el-table-column prop="name" label="服务类型"></el-table-column>
                        <el-table-column prop="servicePeople" label="服务人次"></el-table-column>
                        <el-table-column prop="serviceRatio" :formatter="serviceRatioFucn" label="服务占比"></el-table-column>
                        <el-table-column prop="totalPrice" label="服务总价"></el-table-column>
                    </el-table>
                </template>
            </div>

        </div>

        <!-- <Add ref="myAdd" v-show="showModalAdd" v-bind:areaValue="areaValue" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit"  v-bind:areaValue="areaValue"  v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit> -->

    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    // import Edit from "./Edit";
    // import Add from "./Add";
    import elSelectTree from "../../../components/ElSelectTree"
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                showModalAdd:false,
                showModalEdit:false,
                tableData:null,
                datetimerangeValue:'',
                zoneValue:[],
                idNumber:'',
                phone:'',
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                name:'',
                zoneProps:{
                    emitPath:false,
                    value: 'zoneCode',
                    // 显示的文字字段名
                    label: 'name',
                    // 子层级字段名
                    children: 'listZoneDTO'
                },
            }
        },
        components:{
            elSelectTree
        },
        created(){
            this.init();
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            init(){
                const end = new Date();
                const start=new Date(end - 1000 * 60 * 60 * 24 * 365);
                this.datetimerangeValue=[start, end];
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Zone/ListForStaff",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then( (response)=> {
                    console.log(response);
                    if(response.data.error == 0){
                        var data=JSON.stringify(response.data.data);
                        data=JSON.parse(data.replace(/"listZoneDTO":\[\],/g,''))
                        this.zoneValue = data;
                    }else if(response.data.error == 1){
                        this.$message.error(response.data.message)
                    }
                })
            },
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '总计';
                    return;
                }
                const values = (data || []).map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                    const value = Number(curr);
                    if (!isNaN(value)) {
                        return prev + curr;
                    } else {
                        return prev;
                    }
                    }, 0);
                    if(index==1){
                        sums[index] += ' 人';
                    }else if(index==2){
                        sums[index] = '100%';
                    }else{
                        sums[index] += ' 元';
                    }
                    
                } else {
                    sums[index] = 'N/A';
                }
                });

                return sums;
            },
            download(){
                this.$confirm('是否导出当前列表?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.showModal=true
                    console.log(getStaffCode())
                    var that=this
                    var zoneCode='00000000-0000-0000-0000-000000000000'
                    if(this.zoneCode){
                        zoneCode=this.zoneCode
                    }
                    this.$axios.get(this.$shopUrl+'ExportOldest/GetConsumeSummary',{
                        responseType: 'blob',
                        params:{
                            timeStr: timeStr,
                            sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                            staffCode: getStaffCode(),
                            startTime:timefilters(this.datetimerangeValue[0]),
                            endTime:timefilters(this.datetimerangeValue[1]),
                            zoneCode:zoneCode
                        }
                    }).then(
                        (response) => {
                            var fileName='消费工单分类统计.xlsx'
                            that.file(response,fileName)
                            that.showModal=false
                        }
                    )
                    this.dialogFormVisible=false
                }).catch(e=>e)
            },
            file(response,fileName){
                let blob = new Blob([response.data]);
                if (window.navigator.msSaveOrOpenBlob) {
                    navigator.msSaveBlob(blob,fileName);
                } else {
                    let elink = document.createElement("a");
                    elink.download = fileName;
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href);
                    document.body.removeChild(elink);
                }
            },
            getZoneValue(val){
                this.zoneCode=val
            },
            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            searchGetList(){
                this.getList();
            },
            serviceRatioFucn(row,column,item){
                var value=(item*100).toFixed(2) 
                return value+'%'
            },
            getList(isSearch){
                if(isSearch)this.currentPage=1
                var zoneCode='00000000-0000-0000-0000-000000000000'
                if(this.zoneCode){
                    zoneCode=this.zoneCode
                }
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"GoodsClass/ConsumeSummary",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        startTime:timefilters(this.datetimerangeValue[0]),
                        endTime:timefilters(this.datetimerangeValue[1]),
                        zoneCode:zoneCode
                    }
                }).then( (response)=> {
                    console.log(response);
                    if(response.data.error == 0){
                        this.tableData = response.data.data;
                    }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            applyTypeTitle(row){
                if(row.applyType == 0){
                    return "80-99周岁";
                }
                if(row.applyType == 1){
                    return "100周岁及以上";
                }
            },
            genderTitle(row, column, cellValue){
                if(cellValue == 0){
                    return "女";
                }
                if(cellValue == 1){
                    return "男";
                }
            },



        }
    }
</script>

<style scoped>

</style>
